import { BarChartProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: BarChartProps = {
  items: [1, 2, 3, 4, 5, 6, 7, 8, 9].map(n => ({
    value: 250,
    description: `Option ${n}`,
  })),
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as BarChartProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
